import React, { useCallback } from 'react';

import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';
import InstructorSelect from 'components/InstructorSelect';

export default function SbatGroupOtherInstructorSelect({
  onInstructorsChange,
  ...remainingProps
}) {
  const handleInstructorsChange = useCallback(
    (newInstructor) => {
      onInstructorsChange((prevInstructors) => ({
        ...prevInstructors,
        [INSTRUCTOR_CATEGORIES.other]: newInstructor,
      }));
    },
    [onInstructorsChange]
  );

  return (
    <InstructorSelect
      {...remainingProps}
      isMulti
      placeholder="Select Other Instructors"
      onChange={handleInstructorsChange}
    />
  );
}
